export default __webpack_public_path__ + "images/c1cbae9c1db0d39546ae99d97df186d3.svg";